/* @flow */
import React from 'react';
// $FlowIgnore
import { MdDeviceHub } from 'react-icons/md';

export default function TreeIcon({
  style
}: Object): React.Element {
  return <MdDeviceHub style={style} />;
}
